import * as urls from "utils/contants/urls";

import { YesOrNoDialog } from "components/shared/CustomComponents";
import {
  FilterRegisterLabel,
  Label,
  LabelHeader,
  Table,
  TableBody,
  TableColumn,
  TableHead,
  TableRow,
  ActionItem,
  Actions,
  LabelAction,

} from "components/shared/CustomComponentsStyle";


import {
  ButtonDefault,
  CheckBox,
  SelectFieldInput,
  MultSelect,
  ButtonSecondary
} from "components/shared/CustomInputs";

import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import React, { PureComponent } from "react";
import {
  cancel,

  order as orderIcon,

} from "../../../../assets/icons/icons";


import { FormattedMessage } from "react-intl";

import Load from "components/Layout/Load/Load";

import PropTypes from "prop-types";
import Tab from "components/Tab";
import { ToolTip } from "components/shared/CustomComponents";
import { connect } from "react-redux";
import { Creators as managerActions } from "store/ducks/manager";
import { Input } from "../../../../components/shared/CustomInputsStyle";
import { FlexAction, SubmitRow } from "./SettingsStyle";

const setProfileToUser = (props, idNewPerfil, userId) => {

  const { setProfilerToUser } = props;
  setProfilerToUser({ idNewPerfil, userId });
}


const setFormErros = idintervalo => {

}


const selecionado = false;
const renderTableUsers = (prop, itens) =>
[
  { value: 0, label: "Acesso" },
  { value: 1, label: "Edição" },
  { value: 2, label: "Solicitar vaga" },
  { value: 3, label: "Solicitar demissão" }
].map(user => (
    <TableRow ta="left" key={user.value}>
      <TableColumn ta="left">
        <Label>{user.label}</Label>
      </TableColumn>
      <TableColumn >
        <CheckBox

          type="checkbox" />
      </TableColumn>
    </TableRow >
  ));



const renderTableProfiles = (props, itens) =>
  itens.map(profiler => (
    <TableRow ta="left" key={profiler.id} onClick={() => getProfilePermissions(props, profiler.id)}>


      <TableColumn onClick={() => getProfilePermissions(props, profiler.id)}>
        <Label>{profiler.id}</Label>
      </TableColumn>
      <TableColumn onClick={() => getProfilePermissions(props, profiler.id)}>
        <Label>{profiler.nome}</Label>
      </TableColumn>

    </TableRow>
  ));

const getProfilePermissions = (props, idprofile) => {
  const { getProfilePermissionsList } = props;
  getProfilePermissionsList(idprofile);
}

const enableProfilePermission = (props, id, enabled) => {
  const { setProfilePermission } = props;
  setProfilePermission({ id, enabled });
};

const enableStages = (props, id, enabled) => {
  const { setStageEnable } = props;
  setStageEnable({ id, enabled });
};
const enablePlug = (props, id, enabled) => {
  const { setPlugEnable } = props;
  setPlugEnable({ id, enabled });
};
const enableTalentos = (props, id, enabled) => {
  const { setTalentosEnable } = props;
  setTalentosEnable({ id, enabled });
};
const enableManager = (props, id, enabled) => {
  const { setManagerEnable } = props;
  setManagerEnable({ id, enabled });
};
const deletarUsuario = (props, id) => {
  const { deleteUser } = props;
  deleteUser(id, {});
};
const registerNewProfile = (props, name) => {
  const { createProfile } = props;
  createProfile({ name });
};



function renderTableProfilesPermissions(props, PermissionsProfile) {


  if (PermissionsProfile != undefined) {
    return PermissionsProfile.map(profilerPermission => (
      <TableRow ta="left" key={profilerPermission.id}>

        <TableColumn>

          <CheckBox
            type="checkbox"
            checked={profilerPermission.podeGerenciarLocal}
            onChange={() =>
              enableProfilePermission(props, profilerPermission.idPermissaoSite, !profilerPermission.podeGerenciarLocal)}
          />

        </TableColumn>
        <TableColumn>
          <Label>{profilerPermission.idPermissaoSite}</Label>
        </TableColumn>
        <TableColumn style={{ float: 'left', marginLeft: '80px' }}>
          <Label>{profilerPermission.nomeUnidade}</Label>
        </TableColumn>

      </TableRow>
    ));
  } else {
    return;
  }
};

function renderRowPermissionStage(props, idPermission, PodeEditarEtapas) {

  if (PodeEditarEtapas != undefined) {
    return <TableRow >
      <TableColumn >

        <CheckBox
          type="checkbox"
          checked={PodeEditarEtapas}
          onChange={() => enableStages(props, idPermission, !PodeEditarEtapas)}
        />

      </TableColumn>

      <TableColumn >
        <Label>Habilitar edição de etapas</Label>
      </TableColumn>
    </TableRow>;
  }
  return;
}

class Profiless extends PureComponent {
  constructor() {
    super();
    this.state = {
      profiles: [],
      profilepermissionsSelected: {},
      users: [],
      typing: false,
      focus: 0,
      inputNewProfile: '',
      showDialogYesOrNo: false,
      idDeletar: 0,
      benefits:[]
    }
    this.changeYesOrNoDialog = this.changeYesOrNoDialog.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  requestVacanciesAndSetTab = filter => {
    if (filter.valor == 1) {
      this.setState({ focus: parseInt(filter.valor), filter: filter });
      const { getProfilesList } = this.props;
      getProfilesList();
    }
    else {
      this.setState({ focus: parseInt(filter.valor), filter: filter });
      const { getUsersList } = this.props;
      getUsersList();
    }
  };
  changeYesOrNoDialog(show, id) {
    this.setState({ showDialogYesOrNo: show, idDeletar: id });
  }
  componentDidMount() {
    const { getProfilesList } = this.props;
    getProfilesList();
    const { getUsersList } = this.props;
    getUsersList();

    this.setState({
      columns: [
        {
          name: "Talentos",
          focus: this.state.focus === 0,
          action: this.requestVacanciesAndSetTab,
          filter: { campo: "status", valor: "0", NumeroPagina: 1 }
        },
        {
          name: "Plug",
          focus: this.state.focus === 1,
          action: this.requestVacanciesAndSetTab,
          filter: { campo: "status", valor: "1", NumeroPagina: 2 },
        },
        {
          name: "Mova",
          focus: this.state.focus === 1,
          action: this.requestVacanciesAndSetTab,
          filter: { campo: "status", valor: "2", NumeroPagina: 3 },
        },
        {
          name: "Perfil personalizado",
          focus: this.state.focus === 1,
          action: this.requestVacanciesAndSetTab,
          filter: { campo: "status", valor: "3", NumeroPagina: 4 },
        }
      ],
      profilepermissionsSelected:
      {
        permissaoUnidadeList: []
      }
    });

  }

  static getDerivedStateFromProps(nextProps, state) {
    const profiles = nextProps.profiles.profiles;

    if (nextProps.profiles.profiles != undefined) {
      const profiles = nextProps.profiles.profiles;

      if (state.profiles !== profiles) {
        return { ...state, profiles: profiles };
      }
    }
    if (nextProps.profiles.users != undefined && nextProps.profiles.isLoading == false) {
      const users = nextProps.profiles.users;
      if (state.users !== users) {

        return { ...state, users: users };

      }
    }

    if (nextProps.profiles.profilepermissionsSelected != undefined && nextProps.profiles.isLoading == false) {
      const profilepermissionsSelected = nextProps.profiles.profilepermissionsSelected;
      if (state.profilepermissionsSelected !== profilepermissionsSelected) {

        return { ...state, profilepermissionsSelected: profilepermissionsSelected };
      }

    } else
      return null;

  }

  renderIcon(key) {
    const { order } = this.state;
    return orderIcon({
      style: { transform: `rotate(${order !== key ? "0" : "180deg"})` }
    });
  }

  loadTabOption() {
    
    switch (this.state.focus ) 
    {
      case 0:
      return (

        <React.Fragment>
           <SelectFieldInput
              label={"Selecione um perfil"}
              items={ [
                { id: 0, nome: "Perfil Gestor Matriz" },
                { id: 1, nome: "Perfil Analista" },
                { id: 2, nome: "Perfil Operacional" },
                { id: 3, nome: "Perfil Gestor Site" },
                { id: 4, nome: "Perfil Gestor Ces" },
                { id: 5, nome: "Perfil Recrutador" },
              ]}   
            />
          <MultSelect

              name={"Cargos"}
              value={this.state.benefits}
              options={[
                { value: 0, label: "Almoxarife" },
                { value: 1, label: "Atendente" },
                { value: 2, label: "Coordenador" },
                { value: 3, label: "Gerente" },
                { value: 4, label: "Gestor" },
                { value: 5, label: "Diretor" },
                { value: 6, label: "Presidente" },
              ]}
              label={<FormattedMessage id="inputs.benefits" />}
              isMulti
              onChange={e =>
                this.setState({                  
                  benefits: e ? e.map(k => k) : []
                })
              }
            />
          <Tab columns={this.state.columns}>
            <React.Fragment>
            </React.Fragment>
            <Table >
              <TableBody>
                <TableRow noHover noBorder>
                  <TableHead>
                    <LabelHeader>
                      Permissão
                    </LabelHeader>
                  </TableHead>

                  <TableHead >
                    <LabelHeader>
                      Habilitado
                    </LabelHeader>
                  </TableHead>

                </TableRow>
                {renderTableUsers(this.props, this.state.users, this.state.profiles, this.changeYesOrNoDialog)}
              </TableBody>
              <YesOrNoDialog
                show={this.state.showDialogYesOrNo}
                cancelAction={() => {
                  this.setState({ showDialogYesOrNo: false });
                  this.setState({ idDeletar: 0 })
                }}
                confirmAction={() => {
                  {
                    deletarUsuario(this.props, this.state.idDeletar);
                    this.setState({ showDialogYesOrNo: false });
                  }
                }

                }
                question={<FormattedMessage id="manager.realmenteDesejaDeletar" />}
              />
            </Table>
          </Tab>

        </React.Fragment>

      );
  

    case 1:
      return (
        <React.Fragment>
        <SelectFieldInput
           label={"Selecione um perfil"}
           items={ [
             { id: 0, nome: "Perfil Gestor Matriz" },
             { id: 1, nome: "Perfil Analista" },
             { id: 2, nome: "Perfil Operacional" },
             { id: 3, nome: "Perfil Gestor Site" },
             { id: 4, nome: "Perfil Gestor Ces" },
             { id: 5, nome: "Perfil Recrutador" },
           ]}   
         />
       <MultSelect

           name={"Cargos"}
           value={this.state.benefits}
           options={[
             { value: 0, label: "Almoxarife" },
             { value: 1, label: "Atendente" },
             { value: 2, label: "Coordenador" },
             { value: 3, label: "Gerente" },
             { value: 4, label: "Gestor" },
             { value: 5, label: "Diretor" },
             { value: 6, label: "Presidente" },
           ]}
           label={<FormattedMessage id="inputs.benefits" />}
           isMulti
           onChange={e =>
             this.setState({                  
               benefits: e ? e.map(k => k) : []
             })
           }
         />
       <Tab columns={this.state.columns}>
         <React.Fragment>
         </React.Fragment>
         <Table >
           <TableBody>
             <TableRow noHover noBorder>
               <TableHead>
                 <LabelHeader>
                   Permissão
                 </LabelHeader>
               </TableHead>

               <TableHead >
                 <LabelHeader>
                   Habilitado
                 </LabelHeader>
               </TableHead>

             </TableRow>
             {renderTableUsers(this.props, this.state.users, this.state.profiles, this.changeYesOrNoDialog)}
           </TableBody>
           <YesOrNoDialog
             show={this.state.showDialogYesOrNo}
             cancelAction={() => {
               this.setState({ showDialogYesOrNo: false });
               this.setState({ idDeletar: 0 })
             }}
             confirmAction={() => {
               {
                 deletarUsuario(this.props, this.state.idDeletar);
                 this.setState({ showDialogYesOrNo: false });
               }
             }

             }
             question={<FormattedMessage id="manager.realmenteDesejaDeletar" />}
           />
         </Table>
       </Tab>

     </React.Fragment>
   );

      case 2:
        return (
          <React.Fragment>
          <SelectFieldInput
             label={"Selecione um perfil"}
             items={ [
               { id: 0, nome: "Perfil Gestor Matriz" },
               { id: 1, nome: "Perfil Analista" },
               { id: 2, nome: "Perfil Operacional" },
               { id: 3, nome: "Perfil Gestor Site" },
               { id: 4, nome: "Perfil Gestor Ces" },
               { id: 5, nome: "Perfil Recrutador" },
             ]}   
           />
         <MultSelect

             name={"Cargos"}
             value={this.state.benefits}
             options={[
               { value: 0, label: "Almoxarife" },
               { value: 1, label: "Atendente" },
               { value: 2, label: "Coordenador" },
               { value: 3, label: "Gerente" },
               { value: 4, label: "Gestor" },
               { value: 5, label: "Diretor" },
               { value: 6, label: "Presidente" },
             ]}
             label={<FormattedMessage id="inputs.benefits" />}
             isMulti
             onChange={e =>
               this.setState({                  
                 benefits: e ? e.map(k => k) : []
               })
             }
           />
         <Tab columns={this.state.columns}>
           <React.Fragment>
           </React.Fragment>
           <Table >
             <TableBody>
               <TableRow noHover noBorder>
                 <TableHead>
                   <LabelHeader>
                     Permissão
                   </LabelHeader>
                 </TableHead>

                 <TableHead >
                   <LabelHeader>
                     Habilitado
                   </LabelHeader>
                 </TableHead>

               </TableRow>
               {renderTableUsers(this.props, this.state.users, this.state.profiles, this.changeYesOrNoDialog)}
             </TableBody>
             <YesOrNoDialog
               show={this.state.showDialogYesOrNo}
               cancelAction={() => {
                 this.setState({ showDialogYesOrNo: false });
                 this.setState({ idDeletar: 0 })
               }}
               confirmAction={() => {
                 {
                   deletarUsuario(this.props, this.state.idDeletar);
                   this.setState({ showDialogYesOrNo: false });
                 }
               }

               }
               question={<FormattedMessage id="manager.realmenteDesejaDeletar" />}
             />
           </Table>
         </Tab>

       </React.Fragment>
       );
        
        

        case 3:
          return (
            <React.Fragment>
            <SelectFieldInput
               label={"Selecione um perfil"}
               items={ [
                 { id: 0, nome: "Perfil Gestor Matriz" },
                 { id: 1, nome: "Perfil Analista" },
                 { id: 2, nome: "Perfil Operacional" },
                 { id: 3, nome: "Perfil Gestor Site" },
                 { id: 4, nome: "Perfil Gestor Ces" },
                 { id: 5, nome: "Perfil Recrutador" },
               ]}   
             />
           <MultSelect
 
               name={"Cargos"}
               value={this.state.benefits}
               options={[
                 { value: 0, label: "Almoxarife" },
                 { value: 1, label: "Atendente" },
                 { value: 2, label: "Coordenador" },
                 { value: 3, label: "Gerente" },
                 { value: 4, label: "Gestor" },
                 { value: 5, label: "Diretor" },
                 { value: 6, label: "Presidente" },
               ]}
               label={<FormattedMessage id="inputs.benefits" />}
               isMulti
               onChange={e =>
                 this.setState({                  
                   benefits: e ? e.map(k => k) : []
                 })
               }
             />
           <Tab columns={this.state.columns}>
             <React.Fragment>
             </React.Fragment>
             <Table >
               <TableBody>
                 <TableRow noHover noBorder>
                   <TableHead>
                     <LabelHeader>
                       Permissão
                     </LabelHeader>
                   </TableHead>
 
                   <TableHead >
                     <LabelHeader>
                       Habilitado
                     </LabelHeader>
                   </TableHead>
 
                 </TableRow>
                 {renderTableUsers(this.props, this.state.users, this.state.profiles, this.changeYesOrNoDialog)}
               </TableBody>
               <YesOrNoDialog
                 show={this.state.showDialogYesOrNo}
                 cancelAction={() => {
                   this.setState({ showDialogYesOrNo: false });
                   this.setState({ idDeletar: 0 })
                 }}
                 confirmAction={() => {
                   {
                     deletarUsuario(this.props, this.state.idDeletar);
                     this.setState({ showDialogYesOrNo: false });
                   }
                 }
 
                 }
                 question={<FormattedMessage id="manager.realmenteDesejaDeletar" />}
               />
             </Table>
           </Tab>
 
         </React.Fragment>
           );


    }

  }

  handleChange(event) {
    this.setState({ inputNewProfile: event.target.value });
  }

  render() {


    const { profiles } = this.props;
    if (profiles.isLoading) return <Load isLoading={profiles.isLoading} />;




      return (

        this.loadTabOption()

      );

  }
}


const mapDispatchToProps = dispatch => ({
  getProfilesList: payload => dispatch(managerActions.profilesRequest(payload)),
  getUsersList: payload => dispatch(managerActions.profilesUsersRequest(payload)),
  setProfilerToUser: (idPerfil, IdUser, payload) => dispatch(managerActions.profilesUserUpdateRequest(idPerfil, IdUser, payload)),
  getProfilePermissionsList: (id, payload) => dispatch(managerActions.profilesPermissionsRequest(id, payload)),
  setProfilePermission: (id, enabled, payload) => dispatch(managerActions.profilesEditPermissionsRequest(id, enabled, payload)),
  createProfile: (nome, payload) => dispatch(managerActions.profilesCreateRequest(nome, payload)),
  setStageEnable: (id, enabled, payload) => dispatch(managerActions.profilesEnableStageRequest(id, enabled, payload)),
  setPlugEnable: (id, enabled, payload) => dispatch(managerActions.profilesEnablePlugRequest(id, enabled, payload)),
  setTalentosEnable: (id, enabled, payload) => dispatch(managerActions.profilesEnableTalentosRequest(id, enabled, payload)),
  deleteUser: (id) => dispatch(managerActions.userDeleteRequest(id)),
  setManagerEnable: (id, enabled, payload) => dispatch(managerActions.profilesEnableManagerRequest(id, enabled, payload)),
});
const mapStateToProps = state => ({
  profiles: state.profiles,
  users: state.users
});

Profiless.propTypes = {
  profiles: PropTypes.object,
  users: PropTypes.object,
  getProfilesList: PropTypes.func,
  setProfilerToUser: PropTypes.func,
  getProfilePermissionsList: PropTypes.func,
  createProfile: PropTypes.func,
  setProfilePermission: PropTypes.func,
  setStageEnable: PropTypes.func
};

Profiless.defaultProps = {
  profiles: {},
  users: {},
  getProfilesList: () => { },
  getUsersList: () => { },
  setProfilerToUser: () => { },
  getProfilePermissionsList: () => { },
  setProfilePermission: () => { },
  createProfile: () => { },
  setStageEnable: () => { }


};
export default connect(mapStateToProps, mapDispatchToProps)(Profiless);
